import { TriangleAlertIcon } from 'lucide-react';
import { Button } from '#ui/primitives/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '#ui/primitives/empty';

export type ErrorStateProps = {
  title: string;
  description?: string;
  /** Shown as a retry button when given. */
  onRetry?: () => void;
};

/** The one error state: a failed view says what broke and offers a retry. */
export function ErrorState({ title, description, onRetry }: ErrorStateProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <TriangleAlertIcon />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        {description ? (
          <EmptyDescription>{description}</EmptyDescription>
        ) : null}
      </EmptyHeader>
      {onRetry ? (
        <EmptyContent>
          <Button variant="outline" onClick={onRetry}>
            Try again
          </Button>
        </EmptyContent>
      ) : null}
    </Empty>
  );
}
